const dataService = {
  getNewDeck: async () => {
    const url = "https://deckofcardsapi.com/api/deck/new/shuffle/?deck_count=1";
    try {
      const newDeckID = await fetch(url);
      return await newDeckID.json();
    } catch (error) {
      throw new Error(error);
    }
  },
  getNewCard: async (deckID) => {
    const url = `https://deckofcardsapi.com/api/deck/${deckID}/draw/?count=1
		`;
    try {
      const newCard = await fetch(url);
      return await newCard.json();
    } catch (error) {
      throw new Error(error);
    }
  }
};
export default dataService;
